import Logo from "./logo.js";
import openApiSchema from "./open-api-schema.js";

export default {
	logo: Logo,
	openApiSchema: openApiSchema,
};
